export enum Mode {
  ARTIST = 'artist',
  GENRE = 'genre',
  MOOD = 'mood',
  THEME = 'theme',
  RIGHTSHOLDER = 'rightsholder'
}

export enum Layout {
  GRID,
  LIST,
  CAROUSEL,
}

export interface UIHeroArtist {
  name: string;
  slug: string;
  image: string;
}

export interface UIHeroGenre {
  label: string;
  slug: string;
}

export interface UIHeroTheme {
  label: string;
  slug: string;
  icon?: any;
}


export interface UIHeroTempo {
  label: string;
  slug: string;
}

export interface UILocalTempo {
  range: UIRange,
  label: string
}

export type UIRange = [number, number];

export interface UICreator {
  channel_name: string;
  channel_id: string;
  image: string;
  video_embed: string;
  video_title: string;
}

export interface UIBreadcrumb {
  label: string;
  path: string;
}

export interface UIOpenGraph {
  title?: string;
  description?: string;
  type?: string;
  image?: string;
  url?: string;
}

export type UIBrowseSection = {
  label: string;
  slug: string;
  summary: string;
  image: string;
}